import { Injectable } from '@angular/core';
import { RescheduleAppointmentRequest } from '@app/models/rescheduleAppointmentRequest.model';
import { RescheduleAppointmentResponse } from '@app/models/rescheduleAppointmentResponse.model';
import { Observable } from 'rxjs';
import { AppointmentApiService } from './api/appointment-api.service';
import { PosApiService } from './api/pos-api.service';

@Injectable({
    providedIn: 'root',
})
export class AppointmentService {
    constructor(
        private appointmentApiService: AppointmentApiService,
        private posApiService: PosApiService
    ) {}

    public refreshAppointments(daysmartAccountID: string): Observable<any> {
        return this.appointmentApiService.refreshAppointments(daysmartAccountID);
    }

    public getAppointmentByGuid(daysmartAccountID: string, rescheduleGuid: string): Observable<any> {
        return this.appointmentApiService.getAppointmentByGuid(daysmartAccountID, rescheduleGuid);
    }

    public getAppointmentFromPosApi(daysmartAccountID: string, rescheduleGuid: string): Observable<any> {
        return this.posApiService.getAppointmentByGuid(daysmartAccountID, rescheduleGuid);
    }

    public rescheduleAppointment(request: RescheduleAppointmentRequest): Observable<RescheduleAppointmentResponse> {
        return this.appointmentApiService.rescheduleAppointment(request);
    }
}
